import { Component } from '@angular/core';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-citizen-404-not-found',
  templateUrl: './citizen-404-not-found.component.html',
  styleUrl: './citizen-404-not-found.component.css',
})
export class Citizen404NotFoundComponent {
  url = environment.URL_LINK;
}
